import React from 'react';
import styled from 'styled-components';

const DoubleWide = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  ${(props) => props.theme.media.phone`display: block`};
  ${(props) => props.theme.media.tablet`display: block`};
  align-items: center;
`;

export default DoubleWide;
